import { Controller } from "@hotwired/stimulus";

// Carousel: keeps an "n / total" counter and a row of dots in step with a
// horizontally scrolling snap track whose slides are each one track wide.
//
// The dots work like Instagram's: up to five show at once; past that the row
// slides so the current dot stays in a window of five, and a dot on the
// window's edge shrinks ("far") while more lie beyond it. Each dot's look is
// its `data-state` — active, near or far — styled in the markup.
//
//   data-controller="carousel"
//   data-carousel-target="track" data-action="scroll->carousel#update:passive"
//   data-carousel-target="counter"
//   data-carousel-target="dots"   (one child per slide)
const WINDOW = 5;

export default class extends Controller {
  static targets = ["track", "counter", "dots"];

  connect() {
    this.update();
  }

  update() {
    const track = this.trackTarget;
    const total = track.children.length;
    const index = Math.round(track.scrollLeft / track.clientWidth);
    if (index === this.index) return;
    this.index = index;

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${index + 1} / ${total}`;
    }
    if (this.hasDotsTarget) this.renderDots(index, total);
  }

  renderDots(index, total) {
    const start = Math.min(
      Math.max(index - Math.floor(WINDOW / 2), 0),
      Math.max(total - WINDOW, 0),
    );
    const end = start + WINDOW - 1;

    [...this.dotsTarget.children].forEach((dot, position) => {
      let state = "near";
      if (position === index) state = "active";
      else if (
        (position === start && start > 0) ||
        (position === end && end < total - 1)
      ) {
        state = "far";
      }
      dot.dataset.state = state;
    });

    // Slide the row by whole dots: each dot's box is the row's width / total.
    const step = this.dotsTarget.scrollWidth / total;
    this.dotsTarget.style.transform = `translateX(${-start * step}px)`;
  }
}
